import { Component } from '@angular/core';
import { SidenavService } from '../../../../../../library/src/layout/sidenav/sidenav.service';
import { SidenavState } from '../../../../../../library/src/layout/sidenav/sidenav-state.enum';

@Component({
  selector: 'fury-toolbar-sidenav-mobile-toggle',
  templateUrl: './toolbar-sidenav-mobile-toggle.component.html',
  styleUrls: ['./toolbar-sidenav-mobile-toggle.component.scss']
})
export class ToolbarSidenavMobileToggleComponent {

  constructor(private sidenavService: SidenavService) {
  }

  openSidenavMobile() {
    this.sidenavService.sidenavState = SidenavState.MobileOpen;
  }
}
